const commonFunc = () => {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}

export default () => {
  commonFunc()
  window.addEventListener('resize', () => { commonFunc() });
}